// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__6I4qH","description":"PatientConsentPreview_description__3Mxf9"};